<template>
  <div style="overflow: hidden; padding-top: 100px; padding-bottom: 250px" >
    
    <b-row class="m-0 justify-content-center">
      <div style="width: 1700px; max-width: 90%">
        
        <b-row class="m-0 justify-content-center mt-5">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-info text-white" style="position: relative">
            <h4 class="text-center m-0">{{ chartDataOrders.ordersAmount }} Bestellungen {{ actualMonth.title }} {{ actualMonth.year }}</h4>
          </div>
          <b-form-group
              description="Datum zur Auswertung"
               class="m-3"
               style="max-width: 300px"
            >
              <b-form-datepicker  id="datepicker-orders" v-model="date" :max="max" ></b-form-datepicker>
            </b-form-group>
          <div v-if="orders.length > 0">
            <bar-chart :key="actualMonth.month + actualMonth.year" :chartData="chartDataOrders"/>
          </div>
          <b-row v-else class="m-0 my-3 justify-content-center">
            <div>
              <b-row class="m-0 my-3 justify-content-center">
                <b-img  :src="require(`@/assets/images/undraw_completed.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
              </b-row>
              <h3 class="text-center">Keine Auswertung vorhanden</h3>
            </div>
          </b-row>
          </div>
        </b-row>

        <b-row class="m-0 justify-content-center">
          <div  class="showcase-invert bg-white shadow m-2 mt-4"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-success text-white" style="position: relative">
            <h4 class="text-center m-0">{{ chartDataSales.datasets[0].data[chartDataSales.datasets[0].data.length - 1] + '€' }} Umsatz {{ actualMonth.title }} {{ actualMonth.year }}</h4>
          </div>
          <b-form-group
              description="Datum zur Auswertung"
               class="m-3"
               style="max-width: 300px"
            >
              <b-form-datepicker  id="datepicker-sales" v-model="date" :max="max" ></b-form-datepicker>
            </b-form-group>

          <div v-if="orders.length > 0">
            <line-chart :key="actualMonth.month + actualMonth.year" :chartData="chartDataSales" />
          </div>
          <b-row v-else class="m-0 my-3 justify-content-center">
            <div>
              <b-row class="m-0 my-3 justify-content-center">
                <b-img  :src="require(`@/assets/images/undraw_completed.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
              </b-row>
              <h3 class="text-center">Keine Auswertung vorhanden</h3>
            </div>
          </b-row>
          </div>
        </b-row>

        <b-row class="m-0 justify-content-center">
          <div  class="showcase-invert bg-white shadow m-2 mt-4"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative">
            <h4 class="text-center m-0">Beliebteste Produkte {{ actualMonth.title }} {{ actualMonth.year }}</h4>
          </div>
          <b-row>
            
            <b-form-group
              description="Datum zur Auswertung"
               class="m-3"
               style="max-width: 300px"
            >
              <b-form-datepicker  id="datepicker-products" v-model="date" :max="max" ></b-form-datepicker>
            </b-form-group>
            <b-form-group
              description="Anzahl angezeigter Produkte"
               class="m-3"
               style="max-width: 300px"
            >
              <b-form-input  v-model="limitProducts" type="number" placeholder="Anzahl Produkte"></b-form-input>
            </b-form-group>
          </b-row>
          
          <div v-if="orders.length > 0">
            <bar-chart :key="actualMonth.month + actualMonth.year + limitProducts" :chartData="chartDataProducts"/>
          </div>
          <b-row v-else class="m-0 my-3 justify-content-center">
            <div>
              <b-row class="m-0 my-3 justify-content-center">
                <b-img  :src="require(`@/assets/images/undraw_completed.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
              </b-row>
              <h3 class="text-center">Keine Auswertung vorhanden</h3>
            </div>
          </b-row>
          </div>
        </b-row>

      </div>
    </b-row>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import LineChart from '@/components/charts/LineChart'
import BarChart from '@/components/charts/BarChart'

export default {
  name: 'Statistiken',
  mixins: [coreData],
  components: {
    LineChart,
    BarChart
  }, 
  data: () => {
    const maxDate = new Date()
    return {
      actualMonth: {
        title: 'April',
        month: 3,
        year: 2021
      },
      max: maxDate,
      date: null,
      limitProducts: 10,
      fields: [
        { key: 'date', label: 'Bestellzeit' },
        { key: 'deliveryTime', label: 'Abhol-/Lieferzeit' },
        { key: 'customer', label: 'Kunde' },
        { key: 'amount', label: 'Preis' },
        { key: 'paymentMethods', label: 'Zahlungsmethode' },
        { key: 'orderNumber', label: 'Bestellnummer' },
        { key: 'status', label: 'Status' },
        { key: 'action', label: 'Aktionen' },
      ],
      departmentForm: {},
      newDepartment: false
    }
  },
  watch: {
    date(){
      const months = [
        'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
      ]
      if(this.date){
        this.actualMonth.month = new Date(this.date).getMonth()
        this.actualMonth.year = new Date(this.date).getFullYear()
        this.actualMonth.title = months[new Date(this.date).getMonth()]
      }
    }
  },
  computed: {
    // actualMonth(){
    //   return 'April'
    // },
    chartDataOrders(){
      const data = this.getDaysInMonth(this.actualMonth.month, this.actualMonth.year)
      return {
        labels: data.labels,
        datasets: [
          {
            label: 'Bestellungen',
            data: data.data,
            fill: false,
            borderColor: '#17a2b8',
            backgroundColor: '#17a2b8',
            borderWidth: 1
          }
        ],
        ordersAmount: data.ordersAmount
      }
    },

    chartDataSales(){
      const data = this.getDaysInMonth(this.actualMonth.month, this.actualMonth.year)
      return {
        labels: data.labels,
        datasets: [
          {
            label: 'Umsatz',
            data: data.sales,
            fill: false,
            borderColor: '#28a745',
            backgroundColor: '#28a745',
            borderWidth: 3
          }
        ]
      }
    },

    chartDataProducts(){
      const data = this.getPopularProducts(this.actualMonth.month, this.actualMonth.year)
      return {
        labels: data.labels,
        datasets: [
          {
            label: 'Anzahl',
            data: data.data,
            fill: false,
            borderColor: '#007bff',
            backgroundColor: '#007bff',
            borderWidth: 3
          }
        ]
      }
    },
  },
  mounted(){
    // this.refreshData();
    // this.$store.dispatch('tryAutoLogin')
  },
  methods: {
    getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      var dates = [];
      var data = [];
      var sales = [];
      var price = 0.0;
      var ordersAmount = 0;
      while (date.getMonth() === month) {
        days.push(new Date(date).getDate());
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }

      dates.forEach((date) => {
        let orders = this.orders.filter(order => new Date(order.delivery_time).getDate() == date.getDate() && new Date(order.delivery_time).getMonth() == date.getMonth() && new Date(order.delivery_time).getFullYear() == date.getFullYear())
        data.push(orders.length)
        ordersAmount += orders.length
        orders.forEach(order => {
          if(order.status == 'abgeholt' || order.status == 'bestätigt'){
            price += parseInt(this.getTotalPrice(order))
          }
        })
        sales.push(price)
      })

      return {labels: days, dates: dates, data: data, sales: sales, ordersAmount: ordersAmount};
    },
    getPopularProducts(month, year){
      var date = new Date(year, month, 1);
      var labels = [];
      var dates = [];
      var orderData = []
      var data = []
      while (date.getMonth() === month) {
        dates.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }

      dates.forEach((date) => {
        let orders = this.orders.filter(order => new Date(order.delivery_time).getDate() == date.getDate() && new Date(order.delivery_time).getMonth() == date.getMonth() && new Date(order.delivery_time).getFullYear() == date.getFullYear())
        orders.forEach(order => {
          orderData.push(order.items)
        })
        
      })

      var amounts = []

      orderData.forEach(order => {
        order.forEach(item => {
          var itemData = {
            _id: item._id._id,
            amount: item.amount,
            title: item._id.title
          }
          var checkArray = amounts.find(el => el.itemData._id == item._id._id)

          if(checkArray){
            checkArray.itemData.amount += item.amount
          }else{
            amounts.push({itemData})
          }
          
        })
        
      })

      amounts.sort(function(a, b) {
          var nameA = new Date(a.itemData.amount);
          var nameB = new Date(b.itemData.amount);
          if (nameA < nameB) {
            return 1;
          }
          if (nameA > nameB) {
            return -1;
          }

          return 0;
        });

        amounts.forEach(amount => {
          labels.push(amount.itemData.title)
          data.push(amount.itemData.amount)
        })

      return {labels: labels.slice(0, this.limitProducts), data: data.slice(0, this.limitProducts)};
  }
  }
}
</script>

<style lang="scss" scoped>
</style>